exports.$controller = function($seo) {
  var title = 'Reset Password';
  $seo.set(title);
};

exports.$inject = ['$seo'];
